import type { AlertSeverity, AlertStatus } from '@/types/controlCenter'
import {
  navInputCls,
  navSelectCls,
  addBtnCls,
} from '../components/shared/modalStyles'
import { cap } from '../utils/format'
import { SEVERITY_OPTIONS } from './constants'

export interface AlertsControlsProps {
  severityFilter: AlertSeverity | 'all'
  onSeverityChange: (v: AlertSeverity | 'all') => void
  statusFilter: AlertStatus | 'all'
  onStatusChange: (v: AlertStatus | 'all') => void
  searchQuery: string
  onSearchChange: (v: string) => void
  canEdit: boolean
  onAdd: () => void
}

const AlertsControls = ({
  severityFilter,
  onSeverityChange,
  statusFilter,
  onStatusChange,
  searchQuery,
  onSearchChange,
  canEdit,
  onAdd,
}: AlertsControlsProps) => (
  <>
    <div className='flex w-full items-center gap-2 min-[900px]:w-auto'>
      <select
        value={severityFilter}
        onChange={(e) =>
          onSeverityChange(e.target.value as AlertSeverity | 'all')
        }
        className={`${navSelectCls} flex-1 min-[900px]:flex-none`}
      >
        <option value='all'>All severities</option>
        {SEVERITY_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {cap(s)}
          </option>
        ))}
      </select>
      <select
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value as AlertStatus | 'all')}
        className={`${navSelectCls} flex-1 min-[900px]:flex-none`}
      >
        <option value='all'>All statuses</option>
        {(['active', 'inactive'] as AlertStatus[]).map((s) => (
          <option key={s} value={s}>
            {cap(s)}
          </option>
        ))}
      </select>
    </div>
    <div className='flex w-full items-center gap-2 min-[900px]:w-auto'>
      <input
        type='text'
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder='Search…'
        className={`${navInputCls} flex-1 min-[900px]:w-[160px] min-[900px]:flex-none`}
      />
      {canEdit && (
        <button onClick={onAdd} className={addBtnCls}>
          + Add Alert
        </button>
      )}
    </div>
  </>
)

export default AlertsControls
